import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function Contact() {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [sujet, setSujet] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await emailjs.send(
        'service_n3i28dc', // Remplacez par votre Service ID EmailJS
        'template_n4bo5b3', // Remplacez par votre Template ID EmailJS
        {
          from_name: nom,
          from_email: email,
          subject: sujet,
          message: message,
          to_email: 'cab.jmlc@gmail.com', // Email de destination
        },
        'nUDhbIVhpDxykfPXl' // Remplacez par votre Public Key EmailJS
      );

      setSuccess('Votre message a bien été envoyé');
      setNom('');
      setEmail('');
      setSujet('');
      setMessage('');
    } catch (err) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue lors de l\'envoi du message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <h1>Contact</h1>
      <div className="contact-card">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="nom">Nom</label>
            <input
              type="text"
              id="nom"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="sujet">Sujet</label>
            <input
              type="text"
              id="sujet"
              value={sujet}
              onChange={(e) => setSujet(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows={6}
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button 
            type="submit" 
            className="submit-btn" 
            disabled={loading}
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le message'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;